import { CustomValidator } from "../intake-form/intake-form-validators";
import { requireCompleteDate } from "./patient-portal-error-state-matcher";
import { PatientPortalFormGroupModal } from "./patient-portal-models/patient-portal.model";

export const PATIENT_PORTAL_API = {
  DEV: `https://g2ckh3d5ib.execute-api.us-east-1.amazonaws.com/patientPortal/dev/portal-authentication`,
  PROD: `https://g2ckh3d5ib.execute-api.us-east-1.amazonaws.com/patientPortal/prod/portal-authentication`
} as const;

export const patientPortalDescription: { [key in string]: string } = {
  patientInformation: `Enter your postal code and date of birth exactly as given to the clinic.`,
  patientContactInfo: `Enter the email address you provided to the clinic.`,
  patientAccessCode: `Check your email for the access code and enter it below.`
}

export const patientPortalFormGroupSchema: { [key: string]: { [key: string]: PatientPortalFormGroupModal } } = {

  patientInformation: {
    postalCode: {
      friendlyName: 'Postal Code',
      isDisabled: false,
      validator: [CustomValidator.required]
      // validator: [CustomValidator.required, CustomValidator.pattern(/^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/, `Invalid Postal Code. Must be in the following format: A1A 1A1`)]
    },
    dateOfBirth: {
      friendlyName: 'Date of Birth',
      isDateField: true,
      isDisabled: false,
      validator: [
        CustomValidator.required,
        requireCompleteDate('Select the month, day and year of your date of birth')
      ]
    }

  },
  patientContactInfo: {
    email: {
      friendlyName: 'Please enter your email',
      isDisabled: true,
      validator: [CustomValidator.required, CustomValidator.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, `Enter a valid email (name@domain.com)`)]
    }
  },

  patientAccessCode: {
    accessCode: {
      friendlyName: 'Please enter the Access code',
      isDisabled: true,
      validator: [CustomValidator.required]
    }
  }

};



export const HTTPSTATUS = {
  OK: '200',
  ERROR: '400',
  REDIRECT: '302',
  MAXIMUM: '429'
} as const;